const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        this.teamPopup();
    },

    teamPopup: function() {
		$('.member-block').on('click', function(){
			$(this).next().addClass('open');
			$('body').addClass('body-hidden');
		});
		$('.close-btn').on('click', function(){
			$(this).parent().parent().removeClass('open');
			$('body').removeClass('body-hidden');
		});
	}
}

export default _this;